module.exports = __webpack_public_path__ + "static/media/jth_bg_1.1efbe7b5.jpg";